<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
    text-decoration: none;
  }

  html, body {
    width: 100%;
    height: 100%;
    min-height: 560px;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
  }
  table {
    width: 100%!important;
  }
  .ivu-menu-light.ivu-menu-vertical .ivu-menu-item {
    border-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue